import { Helmet, HelmetProvider } from "react-helmet-async";

 const MetaComponent = ({ title = "Romolo servizi funebri", description="MPM PROJECT web agency" }) => {
    return (
       <HelmetProvider>
           <Helmet>
              <title>{title}</title> 
              <meta name="description" content={description} />
           </Helmet>
       </HelmetProvider> 
    )
 }

 export default MetaComponent